import React, { FC } from "react"

import { Switch as ASwitch } from "antd"

import styles from "./XForm.module.scss"

export type XFormExtensions = {
  Field: typeof Field
  Flexed: typeof Flexed
}

export type XFormProps = {
  children: any
  center?: boolean
  style?: any
  theme?: string
  onSubmit?: () => void
}

export const XForm: FC<XFormProps> & XFormExtensions = ({
  children, theme = "", style = {}, onSubmit = () => false, center = false
}) => {
  return (
    <>
      <form style={style} className={styles.xform + (theme != "" ? " " + styles[theme] : "") + (center ? " " + styles.center : "")} onSubmit={onSubmit}>
        {children}
      </form>
    </>
  )
}

type FieldExtensions = {
  Label: typeof Label
  Input: typeof Input
  Link: typeof Link
  InputMask: typeof InputMask
  // InputDebounce: typeof InputDebounce
  Textarea: typeof Textarea
  Checkbox: typeof Checkbox
  Switch: typeof Switch
  Radio: typeof Radio
}

type FieldProps = { children: any, locked?: boolean, style?: any }
type LabelProps = { title: string, htmlFor?: string, required?: boolean }
type InputProps = { 
  locked?: boolean
  type?: string
  id?: string
  disabled?: boolean
  name?: string
  placeholder?: string
  value: string
  onChange: (ev: any) => void
}
type InputMaskProps = {  }
type InputDebounceProps = {  }
type TextareaProps = { 
  id?: string
  name?: string
  rows?: number
  placeholder?: string
  value: string
  onChange: (ev: any) => void
}
type CheckboxProps = { children?: any }
type SwitchProps = {
  children?: any
  checked?: boolean
  onChange?: (ev: any) => void
}
type RadioProps = { children: any }

type FlexedProps = { 
  children: any
  style?: any
  half?: boolean
  fullwidth?: boolean
}

const Flexed: FC<FlexedProps> = ({ 
  children, style = {}, half = false, fullwidth = false
}) => {
  return (
    <>
      <div className={styles.xform_flexed + (fullwidth ? " " + styles.fullwidth : "") + (half ? " " + styles.half : "")} style={style}>{children}</div>
    </>
  )
}

const Field: FC<FieldProps> & FieldExtensions = ({ 
  children, locked = false, style = {}
}) => {

  const childrenWithProps: any = React.Children.map(children, (child: any) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { locked } as any);
    }
    return child;
  })

  return (
    <>
      <div style={style} className={styles.xform_field + (locked ? " " + styles.locked : "")}>
        {childrenWithProps}
      </div>
    </>
  )
}

const Label: FC<LabelProps> = ({ 
  title, htmlFor, required
}) => {
  return (
    <>
      <label htmlFor={htmlFor}>{title} {required ? <small>*</small> : <></>}</label>
    </>
  )
}

const Input: FC<InputProps> = ({ 
  locked = false, disabled = false, type = "text", id = "", name = "", placeholder = "", value, onChange
}) => {
  return (
    <>
      {locked ? <span>{value}</span> : <input disabled={disabled} type={type} id={id} name={name} placeholder={placeholder} value={value} onChange={onChange} />}
    </>
  )
}

const InputMask: FC<InputMaskProps> = ({  }) => {
  return (
    <>
    
    </>
  )
}

const Textarea: FC<TextareaProps> = ({ 
  id = "", name = "", rows = 5, placeholder = "", value, onChange
}) => {
  return (
    <>
      <textarea id={id} name={name} rows={rows} placeholder={placeholder} value={value} onChange={onChange}></textarea>
    </>
  )
}

const Checkbox: FC<CheckboxProps> = ({ children }) => {
  return (
    <>
    
    </>
  )
}

const Switch: FC<SwitchProps> = ({ 
  children, checked, onChange
}) => {
  return (
    <>
      <div className={styles.xform_switch}><ASwitch checked={checked} onChange={onChange} /> <b>{children}</b></div>
    </>
  )
}

const Radio: FC<RadioProps> = ({ children }) => {
  return (
    <>
    
    </>
  )
}

type LinkProps = {
  children?: any
  href?: string
}

const Link: FC<LinkProps> = ({ children = "", href = "" }) => {
  return (
    <>
      <a className={styles.xlink} href={children == "" ? href : children} target="_blank">{children == "" ? href : children}</a>
    </>
  )
}

XForm.Flexed = Flexed
XForm.Field = Field
Field.Label = Label
Field.Input = Input
Field.Link = Link
Field.InputMask = InputMask
Field.Textarea = Textarea
Field.Checkbox = Checkbox
Field.Switch = Switch
Field.Radio = Radio